import React, { useState, useEffect, FC, PropsWithChildren, useRef } from 'react'
import ReactDOM from 'react-dom'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import { DEFAULT_STYLES, ANIMATION } from './helpers'
import styles from './FlashMessage.module.scss'

const Animation = (props) => {
  const AnimationComponent = dynamic(
    import(
      /* webpackChunkName: "flashAnimation" */
      'components/Animations/Animation'
    ),
    noSSR
  )
  return (
    <AnimationComponent defaultStyles={DEFAULT_STYLES} duration={250} {...ANIMATION} {...props} /> // unfortunatelly still destructing props here because I am not sure all props being passed in each case. fixing for some cases brokes for other, so let's remove all connectors first and then fix this
  )
}

declare let document

type FlashMessagePortalProps = {
  closeFlash: (ev?: any) => void
  isVisible?: boolean
}

const FlashMessagePortal: FC<PropsWithChildren<FlashMessagePortalProps>> = (props) => {
  const { children, closeFlash, isVisible } = props
  const [isReady, setupElements] = useState(false)

  const rootRef = useRef<HTMLElement | null>(null)
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const root = document.getElementById('flash')
    if (!root) {
      return
    }

    const container: HTMLDivElement = document.createElement('div')
    container.className = 'flash'
    if (root && !isReady) {
      // Always Cleanup
      root.innerHTML = ''
      root.appendChild(container)
      setupElements(true)
    }

    rootRef.current = root
    containerRef.current = container

    return () => {
      containerRef.current?.remove()
    }
  }, [])

  if (!isReady || containerRef.current === null) {
    return null
  }

  const AnimatedMessage = (
    <Animation isVisible={isVisible}>
      <div className={styles.flashContainer} onClick={closeFlash}>
        {children}
      </div>
    </Animation>
  )

  return ReactDOM.createPortal(AnimatedMessage, containerRef.current)
}

export default FlashMessagePortal
